import axios from "axios";

/**
 * Client for the .NET ledger service (stock, billing, printing).
 *
 * It authenticates with the SAME admin JWT the rest of the portal uses — the
 * ledger validates Node's token with the shared secret and refuses anything
 * carrying a `stage` claim, exactly as adminAuth.js does. So there is no
 * second login and no service token in the browser, which there must never be:
 * the service token can post to any store's ledger.
 *
 * In production Caddy routes /api/ledger/* to the service on loopback, so the
 * base is just the API host plus that prefix. In local development the service
 * is reached directly on 127.0.0.1:5300, which REACT_APP_LEDGER_URL overrides.
 */
const base =
  process.env.REACT_APP_LEDGER_URL ||
  `${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/api/ledger`;

const ledger = axios.create({ baseURL: base });

ledger.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (!(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});

ledger.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname.startsWith("/admin")) {
      localStorage.removeItem("token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(error);
  }
);

/** The ledger answers failures as { code, message }. Surface that, not "Request failed with status code 409". */
export const ledgerError = (e) =>
  e?.response?.data?.message ||
  e?.response?.data?.code ||
  e?.message ||
  "something went wrong";

export default ledger;
